// eslint-disable-next-line no-promise-executor-return
export const wait = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));
